/**
 * How the welcome page's examples print a word and a figure. Shared by the
 * price preview and the feature sketches, which quote the same example.
 */

/** The example property prices in crowns, as the properties Optivo serves do. */
export const PREVIEW_CURRENCY = "CZK";

/** A weekday name as a label: Intl hands Czech ones back in lower case. */
export function capitalise(text: string, locale: string): string {
    return text.charAt(0).toLocaleUpperCase(locale) + text.slice(1);
}

/** A true minus sign, never a hyphen, in front of a negative figure. */
export function withTrueMinus(text: string): string {
    return text.replace(/-/g, "−");
}

/** The colour a signed amount is printed in: up, down, or left alone. */
export function adjustmentTone(amount: number): string {
    if (amount > 0) return "text-adjustment-up";
    if (amount < 0) return "text-adjustment-down";
    return "text-muted-foreground";
}
